import { Component, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { addKey } from '../../../../functions/add-key';
import { ClaimRow } from '../../../../models/api/view/claim-view/claim-row';
import { ContactDetailResponse } from '../../../../models/api/view/claim/hr/hr-contacts/contactdetail-response';
import { Action } from '../../../../models/core/action';
import { CasePipe } from '../../../../pipes/case.pipe';
import { JoinPipe } from '../../../../pipes/join.pipe';
import { BaseComponent } from '../../../base/base.component';
import { SelectComponent } from '../../../core/controls/select.component';
import { AddressLabelComponent } from '../../../core/labels/address-label.component';
import { PageHeaderComponent } from '../../../core/labels/page-header.component';
import { DetailItemComponent } from '../../../core/panels/detail-panel/detail-item.component';
import { DetailPanelComponent } from '../../../core/panels/detail-panel/detail-panel.component';
import { ColumnComponent } from '../../../core/table/column.component';
import { TableComponent } from '../../../core/table/table.component';
import { HandleLoadingState } from '../../../../decorators/handle-loading-state.decorator';

@Component({
  selector: 'app-hr-contacts',
  imports: [
    DetailPanelComponent,
    DetailItemComponent,
    TableComponent,
    ColumnComponent,
    RouterModule,
    PageHeaderComponent,
    SelectComponent,
    AddressLabelComponent,
    JoinPipe,
    CasePipe,
  ],
  template: `
    <app-page-header label="HR contacts" labelCase="none">
      <ng-template #right>
        <div class="tw-w-64">
          <app-select
            [control]="select"
            [options]="options"
            optionLabel="label"
            optionValue="key"
            [multiple]="false"
            [filter]="false"
            [showClear]="false"
            [showHelpText]="false"
            [virtualScroll]="false"
            (change)="onSelectChange($event)"
          ></app-select>
        </div>
      </ng-template>
    </app-page-header>
    <app-table
      [dataSource]="contactdetail"
      [scrollable]="false"
      [expandable]="true"
      dataKey="_key"
      recordLabel="Contact"
      [loading]="loading"
      [error]="error"
    >
      <app-column
        name="lastName"
        sortName="firstName"
        label="Name"
        classes="tw-font-bold tw-text-sm md:tw-text-base"
      >
        <ng-template let-data>
          {{
            [data.firstName, data.middleInit, data.lastName]
              | join
              | case: 'titlecase'
          }}
        </ng-template>
      </app-column>
      <app-column name="type" label="Type" />
      <app-column name="effectiveDate" label="Effective date" format="d" />
      <app-column name="expirationDate" label="Expiration date" format="d" />

      <ng-template #expand let-data>
        <div class="tw-flex tw-flex-col md:tw-flex-row tw-gap-4 md:tw-gap-8">
          <div
            class="tw-w-full md:tw-basis-1/2 lg:tw-basis-1/3 tw-p-4 md:tw-p-0"
          >
            <app-detail-panel [dataSource]="data" [showEmpty]="true">
              <app-detail-item label="address" name="address">
                <ng-template let-data #value>
                  <div class="tw-break-words">
                    <app-address-label
                      [street1]="data.address"
                      [city]="data.city"
                      [state]="data.state"
                      [postalCode]="data.zip"
                      [country]="data.country"
                    />
                  </div>
                </ng-template>
              </app-detail-item>
              @if (!isTams) {
                <app-detail-item
                  label="home Phone"
                  name="homePhone"
                  format="p"
                />
                <app-detail-item
                  label="work Phone"
                  name="workPhone"
                  format="p"
                />
                <app-detail-item label="fax" name="fax" format="p" />
              }
              <app-detail-item label="email" name="email" />
              @if (!isTams) {
                <app-detail-item label="comments" name="comments" />
              }
            </app-detail-panel>
          </div>
        </div>
      </ng-template>
    </app-table>
  `,
  styles: ``,
})
export class HrContactsComponent extends BaseComponent implements OnInit {
  claim: ClaimRow;
  isTams = false;
  contactdetail: ContactDetailResponse[] = [];
  select = new FormControl<string>('Effective');
  options: Action[] = [
    { key: 'Effective', label: 'Effective' },
    { key: 'Expired', label: 'Expired' },
    { key: 'All', label: 'All' },
  ];
  loading = false;
  error: any = null;

  @HandleLoadingState({ useViewLoading: true })
  async ngOnInit() {
    const claim = this.view.currentClaim();
    this.claim = claim;
    this.isTams =
      this.claim.recordSource === 'T' || this.claim.recordSource === 'R';

    this.dispose.subs = this.select.valueChanges.subscribe((value) => {
      this.onSelectChange(value);
    });
    await this.onSelectChange(this.select.value);
  }

  @HandleLoadingState()
  async onSelectChange(value: any) {
    this.contactdetail = addKey(
      await this.api.contactDetail.search(
        this.claim.recordSource,
        this.claim.recordId,
        value,
      ),
    );
  }
}
